import React from 'react';
import { Card, Collapse, Tag, Typography } from 'antd';
import type { CockpitSideEffectResult } from '../../../../services/devApi';
import RowsTable from './RowsTable';

const { Text } = Typography;

interface Props {
  sideEffects: CockpitSideEffectResult[];
}

const SideEffectHeader: React.FC<{ se: CockpitSideEffectResult }> = ({ se }) => (
  <div className="flex items-center gap-2 flex-wrap">
    <Tag className="font-mono" style={{ marginRight: 0 }}>
      {se.table}
    </Tag>
    <span>{se.label}</span>
    {/* 0 筆不標紅：未核准前是正常的，由 expectWhen 文案幫使用者判讀 */}
    {se.count > 0 ? (
      <Tag color="green" style={{ marginRight: 0 }}>
        ✅ {se.count} 筆
      </Tag>
    ) : (
      <Tag style={{ marginRight: 0, color: '#999' }}>— 0 筆</Tag>
    )}
    <Text type="secondary" style={{ fontSize: 12 }}>
      {se.expectWhen}
    </Text>
    {se.viaInfo && (
      <Text type="secondary" style={{ fontSize: 11 }}>
        via {se.viaInfo}
      </Text>
    )}
  </div>
);

/** 副作用足跡：每個 sideEffect 一列，可展開 rows */
const SideEffectsCard: React.FC<Props> = ({ sideEffects }) => {
  if (sideEffects.length === 0) return null;

  return (
    <Card size="small" title="⚡ 副作用足跡">
      <Collapse
        ghost
        size="small"
        items={sideEffects.map((se) => ({
          key: se.table,
          label: <SideEffectHeader se={se} />,
          collapsible: se.rows && se.rows.length > 0 ? undefined : ('disabled' as const),
          children: <RowsTable rows={se.rows || []} />,
        }))}
      />
    </Card>
  );
};

export default SideEffectsCard;
